import {IUser} from "../../models/security/user-profile.interface";
import {emptyParty} from "@retail-data-factory/rdf-angular-types-api";

export interface IAuthenticatedUserState {
  data: IUser;
  isLoaded: boolean;
}
export const initialAuthenticatedUserState: IAuthenticatedUserState = {
  data:{
    id: '',
    email: '',
    login: '',
    userType: 'NORMAL_USER',
    userProfile:{
      deliverySiteId: '',
      department: '',
      firstName: '',
      lastName: '',
      phone1: '',
      phone2: '',
      jobTitle: ''
    },
    selectedPartyId: '',
    selectedPartyProfile:{
      ...emptyParty
    },
    availableParty: []
  },
  isLoaded: false
};
